import toast from './toast';
import ruleToast from './ruleToast';

export default { toast, ruleToast };



// WEBPACK FOOTER //
// ./src/scripts/utils/notification/index.js